<template>
    <div class="tw-max-w-screen-2xl tw-mx-auto tw-w-full tw-p-2 tw-pt-0 tw-flex tw-items-center tw-justify-center">
        
        <div class="tw-flex tw-items-center tw-gap-2">
            <div v-for="link in links" :key="link.name">
                <router-link 
                :to="link.route"
                :class="{'!tw-text-primary-600 tw-font-semibold': link.route.name == $route.name}"
                class="tw-p-2 tw-text-primary-950 hover:tw-text-primary-600 tw-duration-200"
                >{{ $t(link.name) }}</router-link>
            </div>
        </div>
    </div>
</template>

<script setup>
// import { computed } from 'vue';
// import { useAuthStore } from '@/stores/auth';



// const authStore = useAuthStore();
// const user = computed(() => authStore.user);
// 'pages.' + user.value.role + '.dashboard'

const links = [
    {
        name: 'navigation.home.title',
        route: { name: 'shared.dashboard' }
    },
    {
        name: 'navigation.my-eshow.title',
        route: { name: 'shared.my-eshow' }
    },
    {
        name: 'navigation.companies.title',
        route: { name: 'shared.companies' }
    },
    {
        name: 'navigation.vib-buyers.title',
        route: { name: 'shared.vib-buyers' }
    },
    {
        name: 'navigation.community.title',
        route: { name: 'shared.community' }
    },
    {
        name: 'navigation.speakers.title',
        route: { name: 'shared.speakers' }
    },
    {
        name: 'navigation.agenda.title',
        route: { name: 'shared.agenda' }
    },
    {
        name: 'navigation.products.title',
        route: { name: 'shared.products' }
    },
    {
        name: 'navigation.services.title',
        route: { name: 'shared.services' }
    },
    {
        name: 'navigation.help-desk.title',
        route: { name: 'shared.help-desk' }
    },
    {
        name: 'navigation.foodshow-on-demand.title',
        route: { name: 'shared.foodshow-on-demand' }
    }

]
</script>

